import { render } from "./Login-old.vue?vue&type=template&id=b4136784"
import script from "./Login-old.vue?vue&type=script&lang=js"
export * from "./Login-old.vue?vue&type=script&lang=js"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__